/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Alert API Specification
 * OpenAPI spec version: 0.0.7
 */
import { useMutation, useQuery } from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType,
} from '@tanstack/vue-query';

import { computed, unref } from 'vue';
import type { MaybeRef } from 'vue';

import type {
  AlertCountV2Response,
  AlertListV9Response,
  AlertRuleSummaryResponse,
  AlertTriggeredTargetsResponse,
  DashboardAlertRequestBody,
  GetV9AlertsAlertGroupCountParams,
  GetV9AlertsAlertRulesCurrentParams,
  GetV9AlertsRulesParams,
  GetV9AlertsTriggeredTargetsByAlertResultIdParams,
  PostV9AlertsDashboardAlertGroupRulesByDashboardIdParams,
} from '../../model';

import { customAxiosInstance } from '../../../../common/api/utils/mutator';
import type { ErrorType, BodyType } from '../../../../common/api/utils/mutator';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary 알람 그룹별 개수 조회
 */
export const getV9AlertsAlertGroupCount = (
  params?: MaybeRef<GetV9AlertsAlertGroupCountParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<AlertCountV2Response>(
    { url: `/api/v9/alerts/alert-group/count`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getGetV9AlertsAlertGroupCountQueryKey = (
  params?: MaybeRef<GetV9AlertsAlertGroupCountParams>,
) => {
  return ['api', 'v9', 'alerts', 'alert-group', 'count', ...(params ? [params] : [])] as const;
};

export const getGetV9AlertsAlertGroupCountQueryOptions = <
  TData = Awaited<ReturnType<typeof getV9AlertsAlertGroupCount>>,
  TError = ErrorType<unknown>,
>(
  params?: MaybeRef<GetV9AlertsAlertGroupCountParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV9AlertsAlertGroupCount>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV9AlertsAlertGroupCountQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV9AlertsAlertGroupCount>>> = ({
    signal,
  }) => getV9AlertsAlertGroupCount(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV9AlertsAlertGroupCount>>,
    TError,
    TData
  >;
};

export type GetV9AlertsAlertGroupCountQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV9AlertsAlertGroupCount>>
>;
export type GetV9AlertsAlertGroupCountQueryError = ErrorType<unknown>;

/**
 * @summary 알람 그룹별 개수 조회
 */

export function useGetV9AlertsAlertGroupCount<
  TData = Awaited<ReturnType<typeof getV9AlertsAlertGroupCount>>,
  TError = ErrorType<unknown>,
>(
  params?: MaybeRef<GetV9AlertsAlertGroupCountParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV9AlertsAlertGroupCount>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV9AlertsAlertGroupCountQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary 플랫폼별 현재 발생한 알람 리스트 조회
 */
export const getV9AlertsAlertRulesCurrent = (
  params: MaybeRef<GetV9AlertsAlertRulesCurrentParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<AlertListV9Response>(
    { url: `/api/v9/alerts/alert-rules/current`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getGetV9AlertsAlertRulesCurrentQueryKey = (
  params?: MaybeRef<GetV9AlertsAlertRulesCurrentParams>,
) => {
  return ['api', 'v9', 'alerts', 'alert-rules', 'current', ...(params ? [params] : [])] as const;
};

export const getGetV9AlertsAlertRulesCurrentQueryOptions = <
  TData = Awaited<ReturnType<typeof getV9AlertsAlertRulesCurrent>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV9AlertsAlertRulesCurrentParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV9AlertsAlertRulesCurrent>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV9AlertsAlertRulesCurrentQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV9AlertsAlertRulesCurrent>>> = ({
    signal,
  }) => getV9AlertsAlertRulesCurrent(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV9AlertsAlertRulesCurrent>>,
    TError,
    TData
  >;
};

export type GetV9AlertsAlertRulesCurrentQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV9AlertsAlertRulesCurrent>>
>;
export type GetV9AlertsAlertRulesCurrentQueryError = ErrorType<unknown>;

/**
 * @summary 플랫폼별 현재 발생한 알람 리스트 조회
 */

export function useGetV9AlertsAlertRulesCurrent<
  TData = Awaited<ReturnType<typeof getV9AlertsAlertRulesCurrent>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV9AlertsAlertRulesCurrentParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV9AlertsAlertRulesCurrent>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV9AlertsAlertRulesCurrentQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary 대시보드 알람 그룹별 개수 조회
 */
export const postV9AlertsDashboardAlertGroupCountByDashboardId = (
  dashboardId: MaybeRef<number>,
  dashboardAlertRequestBody: MaybeRef<DashboardAlertRequestBody>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  dashboardId = unref(dashboardId);
  dashboardAlertRequestBody = unref(dashboardAlertRequestBody);

  return customAxiosInstance<AlertCountV2Response>(
    {
      url: `/api/v9/alerts/dashboard/${dashboardId}/alert-group/count`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: dashboardAlertRequestBody,
      signal,
    },
    options,
  );
};

export const getPostV9AlertsDashboardAlertGroupCountByDashboardIdMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV9AlertsDashboardAlertGroupCountByDashboardId>>,
    TError,
    { dashboardId: number; data: BodyType<DashboardAlertRequestBody> },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV9AlertsDashboardAlertGroupCountByDashboardId>>,
  TError,
  { dashboardId: number; data: BodyType<DashboardAlertRequestBody> },
  TContext
> => {
  const mutationKey = ['postV9AlertsDashboardAlertGroupCountByDashboardId'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV9AlertsDashboardAlertGroupCountByDashboardId>>,
    { dashboardId: number; data: BodyType<DashboardAlertRequestBody> }
  > = (props) => {
    const { dashboardId, data } = props ?? {};

    return postV9AlertsDashboardAlertGroupCountByDashboardId(dashboardId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV9AlertsDashboardAlertGroupCountByDashboardIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV9AlertsDashboardAlertGroupCountByDashboardId>>
>;
export type PostV9AlertsDashboardAlertGroupCountByDashboardIdMutationBody =
  BodyType<DashboardAlertRequestBody>;
export type PostV9AlertsDashboardAlertGroupCountByDashboardIdMutationError = ErrorType<unknown>;

/**
 * @summary 대시보드 알람 그룹별 개수 조회
 */
export const usePostV9AlertsDashboardAlertGroupCountByDashboardId = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV9AlertsDashboardAlertGroupCountByDashboardId>>,
      TError,
      { dashboardId: number; data: BodyType<DashboardAlertRequestBody> },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof postV9AlertsDashboardAlertGroupCountByDashboardId>>,
  TError,
  { dashboardId: number; data: BodyType<DashboardAlertRequestBody> },
  TContext
> => {
  const mutationOptions =
    getPostV9AlertsDashboardAlertGroupCountByDashboardIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary 대시보드 발생한 알람 룰 정보
 */
export const postV9AlertsDashboardAlertGroupRulesByDashboardId = (
  dashboardId: MaybeRef<number>,
  dashboardAlertRequestBody: MaybeRef<DashboardAlertRequestBody>,
  params?: MaybeRef<PostV9AlertsDashboardAlertGroupRulesByDashboardIdParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  dashboardId = unref(dashboardId);
  dashboardAlertRequestBody = unref(dashboardAlertRequestBody);
  params = unref(params);

  return customAxiosInstance<AlertRuleSummaryResponse>(
    {
      url: `/api/v9/alerts/dashboard/${dashboardId}/alert-group/rules`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: dashboardAlertRequestBody,
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getPostV9AlertsDashboardAlertGroupRulesByDashboardIdMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV9AlertsDashboardAlertGroupRulesByDashboardId>>,
    TError,
    {
      dashboardId: number;
      data: BodyType<DashboardAlertRequestBody>;
      params?: PostV9AlertsDashboardAlertGroupRulesByDashboardIdParams;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV9AlertsDashboardAlertGroupRulesByDashboardId>>,
  TError,
  {
    dashboardId: number;
    data: BodyType<DashboardAlertRequestBody>;
    params?: PostV9AlertsDashboardAlertGroupRulesByDashboardIdParams;
  },
  TContext
> => {
  const mutationKey = ['postV9AlertsDashboardAlertGroupRulesByDashboardId'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV9AlertsDashboardAlertGroupRulesByDashboardId>>,
    {
      dashboardId: number;
      data: BodyType<DashboardAlertRequestBody>;
      params?: PostV9AlertsDashboardAlertGroupRulesByDashboardIdParams;
    }
  > = (props) => {
    const { dashboardId, data, params } = props ?? {};

    return postV9AlertsDashboardAlertGroupRulesByDashboardId(
      dashboardId,
      data,
      params,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV9AlertsDashboardAlertGroupRulesByDashboardIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV9AlertsDashboardAlertGroupRulesByDashboardId>>
>;
export type PostV9AlertsDashboardAlertGroupRulesByDashboardIdMutationBody =
  BodyType<DashboardAlertRequestBody>;
export type PostV9AlertsDashboardAlertGroupRulesByDashboardIdMutationError = ErrorType<unknown>;

/**
 * @summary 대시보드 발생한 알람 룰 정보
 */
export const usePostV9AlertsDashboardAlertGroupRulesByDashboardId = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV9AlertsDashboardAlertGroupRulesByDashboardId>>,
      TError,
      {
        dashboardId: number;
        data: BodyType<DashboardAlertRequestBody>;
        params?: PostV9AlertsDashboardAlertGroupRulesByDashboardIdParams;
      },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof postV9AlertsDashboardAlertGroupRulesByDashboardId>>,
  TError,
  {
    dashboardId: number;
    data: BodyType<DashboardAlertRequestBody>;
    params?: PostV9AlertsDashboardAlertGroupRulesByDashboardIdParams;
  },
  TContext
> => {
  const mutationOptions =
    getPostV9AlertsDashboardAlertGroupRulesByDashboardIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary 발생한 알람 룰 정보
 */
export const getV9AlertsRules = (
  params?: MaybeRef<GetV9AlertsRulesParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<AlertRuleSummaryResponse>(
    { url: `/api/v9/alerts/rules`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getGetV9AlertsRulesQueryKey = (params?: MaybeRef<GetV9AlertsRulesParams>) => {
  return ['api', 'v9', 'alerts', 'rules', ...(params ? [params] : [])] as const;
};

export const getGetV9AlertsRulesQueryOptions = <
  TData = Awaited<ReturnType<typeof getV9AlertsRules>>,
  TError = ErrorType<unknown>,
>(
  params?: MaybeRef<GetV9AlertsRulesParams>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getV9AlertsRules>>, TError, TData>>;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV9AlertsRulesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV9AlertsRules>>> = ({ signal }) =>
    getV9AlertsRules(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV9AlertsRules>>,
    TError,
    TData
  >;
};

export type GetV9AlertsRulesQueryResult = NonNullable<Awaited<ReturnType<typeof getV9AlertsRules>>>;
export type GetV9AlertsRulesQueryError = ErrorType<unknown>;

/**
 * @summary 발생한 알람 룰 정보
 */

export function useGetV9AlertsRules<
  TData = Awaited<ReturnType<typeof getV9AlertsRules>>,
  TError = ErrorType<unknown>,
>(
  params?: MaybeRef<GetV9AlertsRulesParams>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getV9AlertsRules>>, TError, TData>>;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV9AlertsRulesQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary 대시보드 발생한 알람 룰 정보
 */
export const getV9AlertsTriggeredTargetsByAlertResultId = (
  alertResultId: MaybeRef<string>,
  params?: MaybeRef<GetV9AlertsTriggeredTargetsByAlertResultIdParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  alertResultId = unref(alertResultId);
  params = unref(params);

  return customAxiosInstance<AlertTriggeredTargetsResponse>(
    {
      url: `/api/v9/alerts/${alertResultId}/triggered-targets`,
      method: 'GET',
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getGetV9AlertsTriggeredTargetsByAlertResultIdQueryKey = (
  alertResultId?: MaybeRef<string>,
  params?: MaybeRef<GetV9AlertsTriggeredTargetsByAlertResultIdParams>,
) => {
  return [
    'api',
    'v9',
    'alerts',
    alertResultId,
    'triggered-targets',
    ...(params ? [params] : []),
  ] as const;
};

export const getGetV9AlertsTriggeredTargetsByAlertResultIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getV9AlertsTriggeredTargetsByAlertResultId>>,
  TError = ErrorType<unknown>,
>(
  alertResultId: MaybeRef<string>,
  params?: MaybeRef<GetV9AlertsTriggeredTargetsByAlertResultIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV9AlertsTriggeredTargetsByAlertResultId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV9AlertsTriggeredTargetsByAlertResultIdQueryKey(alertResultId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV9AlertsTriggeredTargetsByAlertResultId>>
  > = ({ signal }) =>
    getV9AlertsTriggeredTargetsByAlertResultId(alertResultId, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!unref(alertResultId)),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV9AlertsTriggeredTargetsByAlertResultId>>,
    TError,
    TData
  >;
};

export type GetV9AlertsTriggeredTargetsByAlertResultIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV9AlertsTriggeredTargetsByAlertResultId>>
>;
export type GetV9AlertsTriggeredTargetsByAlertResultIdQueryError = ErrorType<unknown>;

/**
 * @summary 대시보드 발생한 알람 룰 정보
 */

export function useGetV9AlertsTriggeredTargetsByAlertResultId<
  TData = Awaited<ReturnType<typeof getV9AlertsTriggeredTargetsByAlertResultId>>,
  TError = ErrorType<unknown>,
>(
  alertResultId: MaybeRef<string>,
  params?: MaybeRef<GetV9AlertsTriggeredTargetsByAlertResultIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV9AlertsTriggeredTargetsByAlertResultId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV9AlertsTriggeredTargetsByAlertResultIdQueryOptions(
    alertResultId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}
